import { BaseControlBehaviour } from './BaseControlBehaviour';

/**
 * AutoFocus - устанавливает при загрузке фокус на элемент с аттрибутом bb-auto-focus
 */
export class AutoFocusBehaviour extends BaseControlBehaviour {
    constructor() {
        super('auto-focus');
    }

    protected installBehaviour(element: HTMLElement): void {
        const isFocusedString = $(element).attr('bb-auto-focus');

        const isFocused: boolean = isFocusedString.toLowerCase() == 'true';

        if (isFocused) {
            $(element).focus();
            if (element instanceof HTMLInputElement) {
                element.selectionStart = element.value.length;
            }
        }
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.AutoFocusBehaviour = AutoFocusBehaviour;